import * as React from 'react';
import { Container, Chip } from '@grandvisionhq/elements';
import { H3 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const RelatedLinks = ({ rawResult , relatedLinks  })=>{
    const { getLabel  } = useIntl();
    if (!relatedLinks.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("div", {
        className: "related-links",
        "data-t": "related-links"
    }, /*#__PURE__*/ React.createElement(H3, {
        variant: "smallest"
    }, getLabel('search.relatedLinks.title')), /*#__PURE__*/ React.createElement("ul", null, relatedLinks.map((link)=>/*#__PURE__*/ React.createElement("li", {
            key: link.href,
            className: "related-links__item"
        }, /*#__PURE__*/ React.createElement(Chip, {
            href: link.href
        }, link.label))
    ))), /*#__PURE__*/ React.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: rawResult
        }
    }));
};

export { RelatedLinks };
//# sourceMappingURL=RelatedLinks.js.map
